import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FaFilter, FaSearch, FaTrash } from 'react-icons/fa';
import { Formik } from 'formik';
import {
  Form,
  Button,
  Row,
  Col,
  InputGroup,
  DropdownButton,
  Dropdown,
  Container,
} from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import * as constants from '~/constant';
import { mask, format, createDate } from '~/Utils/Helpers';
import { default as auth } from '~/Utils/AuthStorage';
import SelectGerenteCorretor from '~/Components/GerentesCorretores/SelectGerenteCorretor';
import './ProspectoBuscaFormulario.css';
import { DropdownIndicator, customStyles } from '~/Styles/reactSelectStyles';
import Select from 'react-select';
import * as Yup from 'yup';
import moment from 'moment';
import { getAtendentesCAV } from '~/Services/Service';
import Loading from '~/Components/Loading';

const searchType = {
  nome: {
    label: 'Nome',
    mask: false,
    input: 'text',
  },
  cpf_cnpj: {
    label: 'CPF/CNPJ',
    mask: mask.cpf_cnpj,
    input: 'tel',
  },
  rg_ie: {
    label: 'RG/IE',
    mask: false,
    input: 'text',
  },
  telefone: {
    label: 'Telefone',
    mask: mask.celular,
    input: 'tel',
  },
  email: {
    label: 'Email',
    mask: false,
    input: 'text',
  },
  prospecto: {
    label: 'Prospecto',
    mask: false,
    input: 'tel',
  },
  senha: {
    label: 'Senha',
    mask: false,
    input: 'tel',
  },
};

const optionsDiasInatividade = [
  { value: 5, label: '5 dias' },
  { value: 10, label: '10 dias' },
  { value: 15, label: '15 dias' },
  { value: 20, label: '20 dias' },
  { value: 25, label: '25 dias' },
  { value: 'personalizado', label: 'Personalizado...' },
];

export default function ProspectoBuscaFormulario({
  onSubmit,
  filter,
  empreendimentos,
  isLoading,
  isLoadingOptions,
  filterIsDirty,
  exibirFiltroEtapa = true,
  exibirFiltroGerenteCorretor = true,
  onReset,
  exclude = [],
}) {
  const [showFullSearch, setShowFullSearch] = useState(exclude.length > 0);
  const [mostrarBtnFiltros, setMostrarBtnFiltros] = useState(false);
  const [atendentesCAV, setAtendentesCAV] = useState([]);
  const [loading, setLoading] = useState(false);
  const [
    diasInatividadePersonalizado,
    setDiasInatividadePersonalizado,
  ] = useState(false);

  const bolsaoOptions = [
    { value: false, label: 'Não' },
    { value: true, label: 'Sim' },
  ];

  const defaultValues = {
    tipo_filtro: 'nome',
    codigo_atendente_cav: '',
    filtro: '',
    codigo_gerente: '',
    codigo_corretor: '',
    codigo_empreendimento: '',
    codigo_prospecto_etapa: '',
    data_inicial: '',
    data_final: '',
    tipo_pasta: '',
    origem: '',
    flag_represado_bolsao: false,
    dias_inatividade: '',
  };

  if (auth.isGerente()) {
    defaultValues.codigo_gerente = auth.getUser().usuario;
    defaultValues.codigo_corretor = '';
  }

  if (auth.isCorretor()) {
    defaultValues.codigo_corretor = auth.getUser().usuario;
    defaultValues.codigo_gerente = '';
  }

  const [initialValues, setInitialValues] = useState({
    ...defaultValues,
    ...filter,
  });

  useEffect(() => {
    setLoading(true);

    if (window.location.href.includes('prospectos/lista')) {
      setMostrarBtnFiltros(true);
    }

    getAtendentesCAV()
      .then(res => {
        setAtendentesCAV(res.filter(a => Number(a.status) == 0));
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const searchTypeList = Object.keys(searchType)
    .filter(key => auth.isADM() || auth.isCorretor() || (!auth.isADM() && key !== 'prospecto' || !auth.isCorretor() && key === 'prospecto'))
    .map(key => ({ value: key, label: searchType[key].label }));

  const handleSubmit = values => {
    let request = { ...values };

    if (request.data_inicial) {
      request.data_inicial = createDate(
        values.data_inicial,
        'DD/MM/YYYY'
      ).format(constants.DATE_FORMAT_SERVER);
    }

    if (request.data_final) {
      request.data_final = createDate(values.data_final, 'DD/MM/YYYY').format(
        constants.DATE_FORMAT_SERVER
      );
    }

    if (
      searchType[request.tipo_filtro] &&
      searchType[request.tipo_filtro].input === 'tel'
    ) {
      request.filtro = format.clear(request.filtro);
    }

    if (request.codigo_atendente_cav === 'nao_informado') {
      request.gestor_nao_informado = true;
      request.codigo_atendente_cav = '';
    }
    if (request.codigo_gerente === 'nao_informado') {
      request.imobiliaria_nao_informada = true;
      request.codigo_gerente = '';
    }
    if (request.codigo_corretor === 'nao_informado') {
      request.corretor_nao_informado = true;
      request.codigo_corretor = '';
    }

    onSubmit(request);
  };

  const validationSchema = Yup.object().shape({});

  if (loading) {
    return <Loading />;
  }

  return (
    <Container fluid>
      <span
        className="custom-span"
        style={{
          display: 'block',
          marginBottom: 15,
          fontFamily: "'Open Sans', Arial, sans-serif",
          color: '#2d3a66',
          fontWeight: 700,
          fontSize: 22,
          lineHeight: 1,
          letterSpacing: 0,
        }}
      >
        FILTROS
      </span>
      <Formik
        enableReinitialize={true}
        initialValues={{
          ...(initialValues || {}),
          data_inicial:
            initialValues && initialValues.data_inicial
              ? format.date(initialValues.data_inicial)
              : '',
          data_final:
            initialValues && initialValues.data_final
              ? format.date(initialValues.data_final)
              : '',
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          resetForm,
          dirty,
          errors,
          touched,
          isValid,
          isSubmitting,
          setFieldTouched
        }) => (
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="search.termo">
              <span
                className="custom-span"
                style={{
                  display: 'block',
                  marginBottom: 4,
                  fontFamily: "'Open Sans', Arial, sans-serif",
                  color: '#2d3a66',
                  fontWeight: 700,
                  lineHeight: 1,
                  letterSpacing: 0,
                }}
              >
                Geral
              </span>
              <InputGroup>
                <MaskedInput
                  className="form-control"
                  autoFocus
                  type={searchType[values.tipo_filtro].input}
                  name="filtro"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  mask={searchType[values.tipo_filtro].mask}
                  value={values.filtro}
                  placeholder="Pesquisar por..."
                  style={{ fontFamily: 'Open Sans, Arial, sans-serif' }}
                />
                <DropdownButton
                  as={InputGroup.Append}
                  alignRight
                  variant="outline-secondary"
                  title={searchType[values.tipo_filtro].label}
                  id="input-group-dropdown-tipo-busca"
                  style={{ fontFamily: 'Open Sans, Arial, sans-serif' }}
                >
                  {searchTypeList.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => {
                        if (item.value !== values.tipo_filtro) {
                          setFieldValue(item.value, values[values.tipo_filtro]);
                          setFieldValue(values.tipo_filtro, '');
                          setFieldValue('tipo_filtro', item.value);
                        }
                      }}
                      style={{ fontFamily: 'Open Sans, Arial, sans-serif' }}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </InputGroup>
            </Form.Group>

            <Row>
              <Col>
                <Form.Group controlId="search.codigo_empreendimento">
                  <span
                    className="custom-span"
                    style={{
                      display: 'block',
                      marginBottom: 4,
                    }}
                  >
                    Empreendimento
                  </span>
                  <Select
                    noOptionsMessage={() => 'Nenhum empreendimento encontrado'}
                    placeholder="Pesquisar empreendimentos..."
                    options={[
                      { value: '', label: 'Todos empreendimentos' },
                      ...empreendimentos.sort.map(item => ({
                        value: item.codigo,
                        label: item.descricao,
                      })),
                    ]}
                    onChange={option => {
                      setFieldValue('codigo_empreendimento', option.value);
                      if (option.value === '') {
                        setFieldValue('tipo_pasta ', '');
                      }
                    }}
                    value={
                      values.codigo_empreendimento
                        ? {
                          value: parseInt(
                            empreendimentos.byId[values.codigo_empreendimento]
                              .codigo
                          ),
                          label:
                            empreendimentos.byId[values.codigo_empreendimento]
                              .descricao,
                        }
                        : { value: '', label: 'Todos empreendimentos' }
                    }
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId="search.codigo_atendente_cav">
                  <span
                    className="custom-span"
                    style={{
                      display: 'block',
                      marginBottom: 4,
                    }}
                  >
                    Gestor CAV
                  </span>
                  <Select
                    noOptionsMessage={() => 'Nenhum gestor CAV encontrado'}
                    placeholder="Pesquisar gestores CAV..."
                    options={[
                      { value: '', label: 'Todos gestores CAV' },
                      { value: 'nao_informado', label: 'Não informado' },
                      ...(Array.isArray(atendentesCAV)
                        ? atendentesCAV
                        : []
                      ).map(item => ({
                        value: item.codigo,
                        label: item.descricao,
                      })),
                    ]}
                    onChange={option => {
                      setFieldValue('codigo_atendente_cav', option.value);
                      if (option.value === '') {
                        setFieldValue('tipo_pasta ', '');
                      }
                    }}
                    value={
                      values.codigo_atendente_cav === 'nao_informado'
                        ? { value: 'nao_informado', label: 'Não informado' }
                        : values.codigo_atendente_cav
                        ? (() => {
                          const found = (Array.isArray(atendentesCAV)
                            ? atendentesCAV
                            : []
                          ).find(
                            item =>
                              item.codigo === values.codigo_atendente_cav
                          );
                          return found
                            ? {
                              value: parseInt(found.codigo),
                              label: found.descricao,
                            }
                            : { value: '', label: 'Todos gestores CAV' };
                        })()
                        : { value: '', label: 'Todos gestores CAV' }
                    }
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group controlId="search.origem">
                  <span
                    className="custom-span"
                    style={{ display: 'block', marginBottom: 4 }}
                  >
                    Origem Cadastro
                  </span>
                  <Select
                    placeholder="Todos tipos de cadastro"
                    isSearchable={false}
                    options={[
                      { value: '', label: 'Todos tipos de cadastro' },
                      ...constants.PROSPECTO_ORIGEM_CADASTRO.map(item => ({
                        value: item.value,
                        label: item.label,
                      })),
                    ]}
                    onChange={option => setFieldValue('origem', option.value)}
                    value={
                      values.origem
                        ? {
                          value: values.origem,
                          label: (() => {
                            const found = constants.PROSPECTO_ORIGEM_CADASTRO.find(
                              item => item.value === values.origem
                            );
                            return found
                              ? found.label
                              : 'Todos tipos de cadastro';
                          })(),
                        }
                        : { value: '', label: 'Todos tipos de cadastro' }
                    }
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    name="origem"
                  />
                </Form.Group>
              </Col>
            </Row>
            {!mostrarBtnFiltros && (
              <>
                <Row>
                  <Col>
                    <Form.Group controlId="prospect.tipo_pasta ">
                      <span
                        className="custom-span"
                        style={{ display: 'block', marginBottom: 4 }}
                      >
                        Situação cadastro
                      </span>
                      <Select
                        placeholder="Todos os tipos de cadastro"
                        isSearchable={false}
                        options={[
                          { value: '', label: 'Todos os tipos de cadastro' },
                          ...constants.TIPO_CADASTRO.map(item => ({
                            value: item.value,
                            label: item.label,
                          })),
                        ]}
                        onChange={option =>
                          setFieldValue('tipo_pasta', option.value)
                        }
                        value={
                          values.tipo_pasta
                            ? {
                              value: values.tipo_pasta,
                              label: (() => {
                                const found = constants.TIPO_CADASTRO.find(
                                  item => item.value === values.tipo_pasta
                                );
                                return found
                                  ? found.label
                                  : 'Todos os tipos de cadastro';
                              })(),
                            }
                            : { value: '', label: 'Todos os tipos de cadastro' }
                        }
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        name="tipo_pasta"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {(auth.isADM() || auth.isGerente()) && (
                      <span
                        className="custom-span"
                        style={{ display: 'block', marginBottom: 4 }}
                      >
                        Gerente e Corretor
                      </span>
                    )}
                    <SelectGerenteCorretor
                      gerente={values.codigo_gerente}
                      corretor={values.codigo_corretor}
                      onChangeCorretor={codigoCorretor =>
                        setFieldValue('codigo_corretor', codigoCorretor)
                      }
                      onChangeGerente={codigoGerente =>
                        setFieldValue('codigo_gerente', codigoGerente)
                      }
                      ColSizeMd={6}
                      style={{ fontFamily: 'Open Sans, Arial, sans-serif' }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group controlId="search.codigo_prospecto_etapa">
                      <span
                        className="custom-span"
                        style={{ display: 'block', marginBottom: 4 }}
                      >
                        Etapa
                      </span>
                      <Select
                        placeholder="Todos os status de atendimento"
                        isSearchable={false}
                        options={[
                          {
                            value: '',
                            label: 'Todos os status de atendimento',
                          },
                          ...constants.PROSPECTO_STATUS.map(item => ({
                            value: item.value,
                            label: item.label,
                          })),
                        ]}
                        onChange={option =>
                          setFieldValue('codigo_prospecto_etapa', option.value)
                        }
                        value={
                          values.codigo_prospecto_etapa
                            ? {
                              value: values.codigo_prospecto_etapa,
                              label: (() => {
                                const found = constants.PROSPECTO_STATUS.find(
                                  item =>
                                    item.value ===
                                    values.codigo_prospecto_etapa
                                );
                                return found
                                  ? found.label
                                  : 'Todos os status de atendimento';
                              })(),
                            }
                            : {
                              value: '',
                              label: 'Todos os status de atendimento',
                            }
                        }
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        name="codigo_prospecto_etapa"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group controlId="search.origem">
                      <span
                        className="custom-span"
                        style={{ display: 'block', marginBottom: 4 }}
                      >
                        Lead no Bolsão
                      </span>
                      <Select
                        placeholder="Lead no Bolsão"
                        isSearchable={false}
                        options={bolsaoOptions}
                        onChange={option =>
                          setFieldValue('flag_represado_bolsao', option.value)
                        }
                        value={
                          values.flag_represado_bolsao
                            ? {
                              value: values.flag_represado_bolsao,
                              label: (() => {
                                const found = bolsaoOptions.find(
                                  item =>
                                    item.value ===
                                    values.flag_represado_bolsao
                                );
                                return found ? found.label : 'Não';
                              })(),
                            }
                            : { value: false, label: 'Não' }
                        }
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        name="flag_represado_bolsao"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs="6">
                    <Form.Group controlId="search.data_inicial">
                      <span
                        className="custom-span"
                        style={{ display: 'block', marginBottom: 4 }}
                      >
                        Data inicial
                      </span>
                      <MaskedInput
                        name="data_inicial"
                        type="tel"
                        guide={false}
                        className="form-control"
                        placeholder="Ex.: Cadastro de 29/12/1990"
                        mask={constants.MASK_DATE}
                        value={values.data_inicial}
                        onChange={handleChange}
                        style={{ fontFamily: 'Open Sans, Arial, sans-serif' }}
                      />
                      {touched.data_inicial && errors.data_inicial && (
                        <div style={{ color: 'red', fontSize: '0.875em' }}>
                          {errors.data_inicial}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="6">
                    <Form.Group controlId="search.data_final">
                      <span
                        className="custom-span"
                        style={{ display: 'block', marginBottom: 4 }}
                      >
                        Data final
                      </span>
                      <MaskedInput
                        name="data_final"
                        type="tel"
                        guide={false}
                        className="form-control"
                        placeholder="Ex.: Cadastro Até 29/12/1990"
                        mask={constants.MASK_DATE}
                        value={values.data_final}
                        onChange={handleChange}
                        style={{ fontFamily: 'Open Sans, Arial, sans-serif' }}
                      />
                      {touched.data_final && errors.data_final && (
                        <div style={{ color: 'red', fontSize: '0.875em' }}>
                          {errors.data_final}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
            <Row>
              <Col>
                <Form.Group>
                  <span
                    className="custom-span"
                    style={{ display: 'block', marginBottom: 4 }}
                  >
                    Dias de Inatividade
                  </span>
                  {diasInatividadePersonalizado ? (
                    <div className="d-flex align-items-center">
                      <Form.Control
                        type="number"
                        min="1"
                        max="365"
                        placeholder="Dias"
                        value={values.dias_inatividade}
                        onChange={e => {
                          setFieldValue(
                            'dias_inatividade',
                            e.target.value ? parseInt(e.target.value) : ''
                          );
                        }}
                        onBlur={() => setFieldTouched('dias_inatividade', true)}
                        isInvalid={
                          errors.dias_inatividade && touched.dias_inatividade
                        }
                        style={{ flex: 1 }}
                      />
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        className="ml-2"
                        onClick={() => {
                          setDiasInatividadePersonalizado(false);
                          setFieldValue('dias_inatividade', '');
                        }}
                        title="Voltar para opções"
                      >
                        ✕
                      </Button>
                    </div>
                  ) : (
                    <Select
                      onChange={selectedOption => {
                        if (
                          selectedOption &&
                          selectedOption.value === 'personalizado'
                        ) {
                          setDiasInatividadePersonalizado(true);
                          setFieldValue('dias_inatividade', '');
                        } else {
                          setFieldValue(
                            'dias_inatividade',
                            selectedOption ? selectedOption.value : ''
                          );
                        }
                      }}
                      value={
                        values.dias_inatividade
                          ? optionsDiasInatividade.find(
                              opt => opt.value === values.dias_inatividade
                            ) || null
                          : null
                      }
                      options={optionsDiasInatividade}
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      placeholder="Todos..."
                      isClearable={true}
                      name="dias_inatividade"
                    />
                  )}
                  {errors.dias_inatividade && touched.dias_inatividade && (
                    <Form.Text className="text-danger">
                      {errors.dias_inatividade}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end mt-3">
              {window.location.href.includes('prospectos/lista') && (
                <Button
                  type="button"
                  variant="outline-primary"
                  style={{
                    fontFamily: 'Open Sans, Arial, sans-serif',
                    marginRight: 12,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                  }}
                  onClick={() => {
                    setMostrarBtnFiltros(!mostrarBtnFiltros);
                  }}
                >
                  <span>{!mostrarBtnFiltros ? ' - ' : ' + '}</span>
                  <span className="d-none d-md-block">Filtros</span>
                </Button>
              )}
              <Button
                type="button"
                variant="outline-danger"
                style={{
                  fontFamily: 'Open Sans, Arial, sans-serif',
                  marginRight: 12,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                }}
                onClick={() => {
                  resetForm();
                  if (typeof onReset === 'function') onReset();
                }}
                disabled={isLoading}
              >
                <FaTrash />
                <span className="d-none d-md-block">Limpar filtro</span>
              </Button>
              <Button
                type="submit"
                disabled={isLoading || !isValid}
                style={{
                  background: '#419AEF',
                  borderColor: '#419AEF',
                  fontFamily: 'Open Sans, Arial, sans-serif',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                }}
              >
                <FaSearch
                  color="#fff"
                  style={{
                    stroke: '#fff',
                    strokeWidth: 32,
                    verticalAlign: 'middle',
                  }}
                />
                {isLoading ? (
                  <span className="d-none d-md-block">
                    Aplicando filtros...
                  </span>
                ) : (
                  <span className="d-none d-md-block">Aplicar filtro</span>
                )}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Container>
  );
}

ProspectoBuscaFormulario.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  filter: PropTypes.object,
  empreendimentos: PropTypes.object.isRequired,
  isLoading: PropTypes.any,
  isLoadingOptions: PropTypes.any,
  filterIsDirty: PropTypes.any,
  onReset: PropTypes.func,
  exclude: PropTypes.array,
};
